import { useEffect, useMemo, useState } from "react";
import { api } from "../lib/api";
import CrudTable from "../components/CrudTable";
import PDFButton from "../components/PDFButton";
import WarehouseCapacityPanel from "../components/WarehouseCapacityPanel";
import { Modal, FileCCE } from "../components/ui";

const TABS = [
  { key: "RP",  label: "Almacén RP" },
  { key: "RME", label: "Almacén RME" },
  { key: "RSU", label: "Almacén RSU" },
];

const STATUSES = ["Solicitud iniciada", "En revisión", "Abierta", "Atendida"];

export default function WasteIntake() {
  const [tab, setTab] = useState("RP");
  return (
    <div style={{ display: "flex", height: "100%", minHeight: 600 }} data-testid="waste-intake-shell">
      <div style={{ flex: 1, overflow: "auto", paddingRight: 12 }}>
        <div data-testid="waste-intake-module">
          <div className="flex items-center justify-between mb-3">
            <h1 className="card-h1" style={{ margin: 0 }}>Citas de almacén — Recepción de residuos</h1>
            <PDFButton endpoint="/pdf/module/racs" filename={`citas_almacen_${tab}.pdf`} label="Reporte PDF" />
          </div>
          <p className="text-xs text-dim mb-3">
            Programación de recepción de residuos en almacenes. Una vez atendida la cita el sistema crea
            automáticamente la entrada correspondiente en la bitácora del tipo de residuo.
          </p>
          <div className="tabs-bar">
            {TABS.map((t) => (
              <button key={t.key} className={`tab ${tab === t.key ? "active" : ""}`} onClick={() => setTab(t.key)} data-testid={`wi-tab-${t.key}`}>{t.label}</button>
            ))}
          </div>
          <IntakeTable type={tab} />
        </div>
      </div>
      <WarehouseCapacityPanel />
    </div>
  );
}

function IntakeTable({ type }) {
  const [schedules, setSchedules] = useState([]);
  const [staffList, setStaffList] = useState([]);

  async function loadHist() {
    try {
      const { data } = await api.get("/data/waste_intake_appointments");
      const sched = Array.from(new Set((data || []).map((r) => r.schedule).filter(Boolean)));
      const staff = Array.from(new Set((data || []).map((r) => r.receiver_name).filter(Boolean)));
      setSchedules(sched);
      setStaffList(staff);
    } catch (e) { console.error(e); }
  }
  useEffect(() => { loadHist(); }, []);

  const fields = useMemo(() => ([
    { key: "request_number", label: "Solicitud # (SOLICITUD)", required: true },
    { key: "date", label: "Fecha de cita", type: "date", required: true },
    { key: "applicant_name", label: "Nombre del solicitante" },
    { key: "applicant_file_id", label: "Ficha del solicitante" },
    { key: "schedule", label: "Horario de atención (texto libre)", autocomplete: schedules },
    { key: "receiver_name", label: "Personal ambiental que recibe", autocomplete: staffList },
    { key: "waste_type_specific", label: "Tipo de residuos a ingresar" },
    { key: "volume", label: "Volumen / Cantidad", type: "number" },
    { key: "unit", label: "Unidad", type: "select", options: ["kg","ton","L","m³","pza"] },
    { key: "description", label: "Descripción del residuo", type: "textarea", full: true },
    { key: "status", label: "Status", type: "select", options: STATUSES, default: "Solicitud iniciada" },
    { key: "type", label: "Tipo (RP/RME/RSU)", default: type, hiddenInForm: true, hidden: true },
    { key: "comments", label: "Comentarios", type: "textarea", full: true },
  ]), [schedules, staffList, type]);

  return (
    <CrudTable
      key={type}
      collection="waste_intake_appointments"
      filters={{ type }}
      testIdPrefix={`wi-${type}`}
      onAfterSave={(row) => {
        // When marked "Atendida", auto-create a waste_weighing entry in the bitácora
        if (row?.status === "Atendida" && row.volume) {
          api.post("/data/waste_weighings", {
            type,
            date: row.date,
            description: row.description || row.waste_type_specific,
            weight_kg: Number(row.volume) || 0,
            area: row.schedule || "Almacén",
            received_by: row.receiver_name || "",
            movement: "Disposicion",
          }).catch((e) => console.error("No se pudo crear weighing:", e));
        }
        loadHist();
      }}
      fields={fields}
    />
  );
}
